<template>
  <div>
    <el-carousel :height="bannerHeight + 'px'">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div style="position: relative; width: 100%">
          <img
            :src="item.url"
            alt="img"
            ref="bannerHeight"
            style="width: 100%"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
    <!--企业介绍-->
    <company-info></company-info>
    <!--信息化系统-->
    <info-system></info-system>
    <!--成功案例-->
    <success-case id="case"></success-case>
    <!-- 新闻动态 -->
    <news></news>
    <!-- section4 -->
    <div class="section4-wrap">
      <div class="section4">
        <div>眼见为实 , 即刻联系</div>
        <el-button class="btn" @click="state = true">预约演示</el-button>
      </div>
    </div>
    <!--  modal  -->
    <el-dialog title="预约演示申请" :visible.sync="state" width="30%">
      <el-form ref="appointForm" :model="appointForm" :rules="appointFormRules">
        <el-form-item prop="name">
          <el-input
            v-model="appointForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            v-model="appointForm.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enterpriseName">
          <el-input
            v-model="appointForm.enterpriseName"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" style="width: 100%">
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import banner1 from "../assets/banner/banner1.png";
import banner2 from "../assets/banner/banner2.png";
import banner3 from "../assets/banner/banner3.png";
import CompanyInfo from "@/views/component/company-info.vue";
import infoSystem from "@/views/component/info-system.vue";
import SuccessCase from "@/views/component/successCase.vue";
import News from "@/views/component/news.vue";
export default {
  name: "Home",
  components: {
    CompanyInfo,
    infoSystem,
    News,
    SuccessCase,
  },
  props: ["scWidth"],
  data() {
    return {
      deviceType: localStorage.getItem("deviceType"),
      bannerHeight: "", // 轮播图高度
      // 轮播图数据
      bannerList: [
        { url: banner1, type: "1" },
        { url: banner2, type: "2" },
        { url: banner3, type: "3" },
      ],
      state: false, // modal state
      appointForm: {
        name: "",
        phone: "",
        enterpriseName: "",
      },
      appointFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.setSize();
    window.addEventListener(
      "resize",
      () => {
        this.setSize();
      },
      false
    );
  },
  methods: {
    // 提交form
    handleSubmit() {
      this.$refs["appointForm"].validate((success) => {
        if (success) {
          fetch("/prod-api/system/form", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.appointForm),
          })
            .then((res) => {
              return res.json();
            })
            .then((res) => {
              this.state = false;
              this.appointForm = {
                name: "",
                phone: "",
                enterpriseName: "",
              };
              if (res.code === 200) {
                this.$message.success("提交成功");
              } else {
                this.$message.error("提交失败");
              }
            });
        }
      });
    },
    setSize() {
      this.bannerHeight = document.body.clientWidth / 3.84; //这个比例是1920/500
    },
  },
};
</script>
<style lang="less" scoped>
// 功能优势 start
.section3-wrap {
  width: 1200px;
  margin: 0 auto;
  .section3-title {
    color: #296db2;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    margin-top: 98px;
  }
  .section3-sub-title {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-top: 14px;
  }
  .section3-content {
    margin-top: 40px;
    width: 100%;
  }
}
// section3 end

// section4
.section4-wrap {
  width: 100%;
  height: 250px;
  background: url("../assets/section4.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 62px;
  .section4 {
    color: #fff;
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    .btn {
      width: 160px;
      height: 50px;
      margin-top: 30px;
      color: #125497;
      font-size: 18px;
    }
  }
}
// section4 end
// 功能优势的tab组件样式
.tabs-title {
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  .item-tab:hover {
    cursor: pointer;
  }
  .item-tab-active {
    color: #296db2;
  }
  .item-tab-active::after {
    content: "";
    width: 35px;
    height: 3px;
    display: block;
    margin: 10px auto 0;
    background-color: #296db2;
  }
}
.tabs-content {
  width: 1200px;
  height: 372px;
  background: #f6f8fa;
  display: flex;
  align-items: center;
  padding-left: 45px;
  padding-right: 50px;
  box-sizing: border-box;
  .item-content {
    height: 100%;
    display: flex;
    align-items: center;

    .item {
      display: flex;
      align-items: flex-start;

      .item-content-left {
        width: 414px;
        margin-right: 48px;
        .item-content-left-title {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
        }
        .item-content-left-text {
          margin-top: 30px;
          line-height: 28px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
}
// tab css end

.img {
  width: 100%;
}
// tab img
.tab-img {
  height: 233px;
}
</style>
